import { Brand } from 'types/brand';
import { PointOfSale } from 'types/point-of-sale';
import { Address } from '../address';

export type Store = {
  name: string | null;
  brand: Brand;
  access: string;
};

export type StoresByBrand = {
  brand: Brand;
  stores: string[];
  access: string;
};

export type OpeningDay = {
  closingTime: number;
  open: boolean;
  openingTime: number;
  weekday: string;
};

export type GeoPoint = {
  latitude: number;
  longitude: number;
};

export type BasicPointOfService = {
  name: string;
};

export enum KycStatus {
  Undefined = 'UNDEFINED',
  WithoutPspAccount = 'WITHOUT_PSP_ACCOUNT',
  WithoutVendorRegisterInformation = 'WITHOUT_VENDOR_REGISTER_INFORMATION',
  BlockedKyc = 'BLOCKED_KYC',
  IncompletedKyc = 'INCOMPLETED_KYC',
  CompletedKyc = 'COMPLETED_KYC',
}

export enum PosType {
  Franchise = 'FRANCHISE',
  OwnBusines = 'OWN_BUSINESS',
  NA = '',
}

export type PointOfService = {
  bankDocument: string;
  name: string;
  displayName: string;
  baseStore: Brand;
  phone: string;
  openingHoursMessage: string;
  discountAllowed: number;
  posType: PosType;
  participateInPickUpStore: boolean;
  participateInStoreShipping: boolean;
  address: Address;
  notificationEmail: string[];
  geoPoint: GeoPoint;
  openingDays: OpeningDay[];
  openingDaysHistory?: OpeningDaysHistory[];
  invoicePointOfSale: PointOfSale | null;
  taxCouponPointOfSale: PointOfSale | null;
  manualPointOfSale: PointOfSale | null;
  exchangeOmniEnable: boolean | null;
  kycStatus: KycStatus.Undefined | null;
};

export type OpeningDaysHistory = {
  changeBy: string;
  weekday: string;
  date: Date;
  entries: {
    newDate: number;
    oldDate: number;
    type: string;
  }[];
};

export type BaseStore = {
  pickUpConfiguration: { radius: number };
  storeShippingConfiguration: { radius: number };
  uid: string;
};
